import { UserBonusCardCheckpointsProps } from '../props';
import UserBonusCardCheckpointsV2 from './V2';

export default function UserBonusCardCheckpointsRenderer(
  props: UserBonusCardCheckpointsProps,
) {
  return <UserBonusCardCheckpointsV2 {...props} />;
}
